<button
  data-test="Tt2n_Qiz"
  style="padding: 4px; cursor: pointer"
  style="float: right"
  (click)="close()"
>
  <span data-test="6eHfX5Zt" class="badge badge_gray">
    <i data-test="74gZbrMD" class="material-icons md-12">close</i>
  </span>
</button>
<h1 data-test="IZ7Dq4po" mat-dialog-title style="text-align: center; padding-top: 38px">
  {{
    data.id
      ? 'Where rate sheet should be applied?'
      : 'Where rate sheet should be deleted?'
  }}
</h1>
<div
  data-test="aPpiKqvF"
  mat-dialog-content
  style="padding-bottom: 18px; padding-left: 58px"
>
  <div data-test="Nb98WO-p">
    <label data-test="AyvMDbkm" class="checkbox" *ngIf="isTeamTask">
      <input data-test="fZxRQO71" type="checkbox" [(ngModel)]="applyInTeamTask" />
      <span data-test="YvN7Op-i" class="checkbox__label">Only here (Team & task)</span>
      <span data-test="r3klJLXJ" class="checkbox__marker">
        <span data-test="VSriQ8_P" class="checkbox__marker-icon">
          <svg
            data-test="lj-Fr-EG"
            class="icon__icon-check"
            width="9.07px"
            height="6.95px"
          >
            <use xlink:href="#icon-check"></use>
          </svg>
        </span>
      </span>
    </label>
  </div>
  <div data-test="z4pUTHsv">
    <label data-test="YD_bgdT-" class="checkbox">
      <input
        data-test="v-Ob1ThN"
        type="checkbox"
        [(ngModel)]="applyInChannelSuggestion"
      />
      <span data-test="pb2aeyQW" class="checkbox__label">
        {{ isTeamTask ? 'Channel suggestion' : 'Only here (Channel suggestion)' }}
      </span>
      <span data-test="W59iC1xD" class="checkbox__marker">
        <span data-test="7_r9F5rh" class="checkbox__marker-icon">
          <svg
            data-test="zDMpy3dD"
            class="icon__icon-check"
            width="9.07px"
            height="6.95px"
          >
            <use xlink:href="#icon-check"></use>
          </svg>
        </span>
      </span>
    </label>
  </div>
  <div data-test="ViburUEX">
    <label data-test="GHksNRll" class="checkbox">
      <input data-test="TBIFZTcG" type="checkbox" [(ngModel)]="applyInAllActionTeams" />
      <span data-test="IxeW3GcS" class="checkbox__label">
        {{ isTeamTask ? 'All action teams' : 'Here and all action teams' }}
      </span>
      <span data-test="hF0FJ0OK" class="checkbox__marker">
        <span data-test="JUVYk7Cw" class="checkbox__marker-icon">
          <svg
            data-test="DAFuAVtD"
            class="icon__icon-check"
            width="9.07px"
            height="6.95px"
          >
            <use xlink:href="#icon-check"></use>
          </svg>
        </span>
      </span>
    </label>
  </div>
</div>
<footer
  data-test="vy0_jQx0"
  class="rs-modal-actions modal__footer_white modal__footer_grow"
>
  <div data-test="vwHqArHS" class="modal__container">
    <div
      data-test="8GOjwMHc"
      class="row align-items-center justify-content-center gutters-20"
    >
      <div data-test="PVAQr3VJ" class="col">
        <button
          data-test="3qT5Bm_5"
          class="button_ button button_secondary button_text-14"
          (click)="close()"
        >
          Cancel
        </button>
      </div>
      <div data-test="LsKDFlLz" class="col">
        <button
          data-test="b2hZK9dq"
          class="button_ button button_primary button_text-14"
          data-close="modal"
          (click)="submit()"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</footer>
